export const imageBorderRadius = "0.9375rem"
